<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1101001000012ogvtn.vue
*@ 컴포넌트설명 :[베트남] 예금 상품 > 예금 상품 상세(기업보통예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <section class="deposit detail">
    <!--한국어-->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>기업보통예금</h2>
          </div>
          <div class="description">
            <p>
              일시적 여유자금 보관목적의 입금 및 출금이 자유로운 예금
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
                <span class="text">연 </span>
              </div>
              <div class="percent">
                0.00%
              </div>
            </div>
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">VND</span>
                <span class="text">연 </span>
              </div>
              <div class="percent">
                0.10%
              </div>
            </div>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품유형</dt>
            <dd>보통예금</dd>
            <dt>상품개요</dt>
            <dd>일시적 여유자금 보관목적의 입금 및 출금이 자유로운 예금</dd>
            <dt>가입대상</dt>
            <dd>베트남 또는 외국 법령에 따라 설립되고 운영되는 법인</dd>
            <dt>계약기간</dt>
            <dd>제한없음</dd>
            <dt>가입통화</dt>
            <dd>VND, USD</dd>
            <dt>가입금액</dt>
            <dd>제한없음</dd>
            <dt>금리 및 이율</dt>
            <dd>약정이율 : USD 연 0.00%, VND 연 0.10%</dd>
            <dt>수수료</dt>
            <dd>해당무</dd>
            <dt>가입방법</dt>
            <dd>영업점가입</dd>
            <dt>가입시 필요서류</dt>
            <dd>
              · 법적 설립 근거를 증명할수 있는 설립인가서나 법적서류<br />
              · 회사를 대표하여 법적으로 권리를 행상할 수 있는 대표자를 확인해주는 서류<br />
              · 대표자의 공인 신분증 혹은 여권 및 서명 표본<br />
              · 대표자의 위임장(대표자외 다른 사람이 예금주가 되는 경우)<br />
              · 수임인의 서명 등록 및 계좌관리범위(대표자외 다른 사람이 예금주가 되는 경우)<br />
              · 수임인의 공인신분증 혹은 여권 및 서명표본(대표자와 다른 사람이 예금주가 되는 경우)
            </dd>
            <dt>유의사항 및 기타</dt>
            <dd>최소유지 잔액 USD 10.00</dd>
          </dl>
        </article>
      </div>
    </template>
    <!--영어-->
    <template v-else-if="lang == $config.LANG_ENG">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>BUSINESS CURRENT ACCOUNT</h2>
          </div>
          <div class="description">
            <p>
              Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
              </div>
              <div class="percent">
                0.00% annually
              </div>
            </div>
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">VND</span>
              </div>
              <div class="percent">
                0.10% annually
              </div>
            </div>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Types</dt>
            <dd>Current Account</dd>
            <dt>About the products</dt>
            <dd>Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds</dd>
            <dt>Eligibilty</dt>
            <dd>The Corporation that is established and operated in accordance with the laws and regulations of Vietnamese or foreign country</dd>
            <dt>Contract Terms</dt>
            <dd>No restrictions</dd>
            <dt>Available currency</dt>
            <dd>VND, USD</dd>
            <dt>Deposit amount</dt>
            <dd>No restrictions</dd>
            <dt>Loan Rate</dt>
            <dd>Agreed interest rate : USD 0.00% annually , VND 0.10% annually</dd>
            <dt>Fees</dt>
            <dd>N/A</dd>
            <dt>How to apply</dt>
            <dd>Apply at the branch</dd>
            <dt>Required documents for application</dt>
            <dd>
              -Business license or legal documents to prove the legality of the company<br />
              -Documents to confirm the representative who can exercise the rights of the company<br />
              -Representative's official ID, passport or signed copy<br />
              -Representative's letter of attorney (if the account holder is not the representative)<br />
              -Delegated person's range of account management and registration of his/her signature (if the account holder is not the representative)<br />
              -Delegated person's ID, passport or signed copy (If the account holder is not the representative)
            </dd>
            <dt>Notices and others</dt>
            <dd>Minimum balance to maintain : USD 10.00</dd>
          </dl>
        </article>
      </div>
    </template>
    <!--베트남-->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>Tiền gửi thanh toán doanh nghiệp</h2>
          </div>
          <div class="description">
            <p>
              Là hình thức tiền gửi mà quý khách có thể tự do nạp và rút tiền mà không cần phải ấn định thời gian
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item">
              <div class="tit">
                <span class="exchange-unit">USD</span>
              </div>
              <div class="percent">
                0.00%/năm
              </div>
            </div>
            <div class="item">
              <div class="tit">
                <span class="exchange-unit">VND</span>
              </div>
              <div class="percent">
                0.10% /năm
              </div>
            </div>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Hình thức sản phẩm</dt>
            <dd>Tiền gửi thông thường</dd>
            <dt>Giới thiệu sản phẩm</dt>
            <dd>Là hình thức tiền gửi mà quý khách có thể tự do nạp và rút tiền mà không cần phải ấn định thời gian</dd>
            <dt>Đối tượng gia nhập</dt>
            <dd>Pháp nhân được thành lập và hoạt động theo pháp luật Việt Nam hoặc pháp luật nước ngoài</dd>
            <dt>Thời gian hợp đồng</dt>
            <dd>Không giới hạn</dd>
            <dt>Loại tiền tệ gia nhập</dt>
            <dd>VND, USD</dd>
            <dt>Số tiền gia nhập</dt>
            <dd>Không giới hạn</dd>
            <dt>Lãi suất</dt>
            <dd>Lãi suất cam kế t: USD 0.00% một năm, VND 0.10% một năm</dd>
            <dt>Biểu phí</dt>
            <dd>Không có nội dung tương ứng</dd>
            <dt>Cách thức gia nhập</dt>
            <dd>Tham gia chi nhánh</dd>
            <dt>Giấy tờ cần thiết khi gia nhập</dt>
            <dd>
              - Giấy phép thành lập hoặc hồ sơ pháp lý chứng minh việc thành lập hợp pháp.<br />
              - Tài liệu chứng minh người đại diện có thể ủy quyền pháp lý đại diện cho công ty.<br />
              - CMND hoặc hộ chiếu hoặc mẫu chữ ký công chứng của người đại diện.<br />
              - Giấy ủy quyền của người đại diện ( trường hợp không phải là người đại diện gửi tiền )<br />
              - Đăng ký chữ ký của người được ủy quyền, phạm vi quản lý tài khoản ( trường hợp không phải là người đại diện gửi tiền )<br />
              - CMND hoặc hộ chiếu hoặc mẫu chữ ký công chứng của người được ủy quyền ( trường hợp không phải là người đại diện gửi tiền )
            </dd>
            <dt>Lưu ý</dt>
            <dd>Số dư tối thiểu để duy trì tài khoản 10.00 USD</dd>
          </dl>
        </article>
      </div>
    </template>
  </section>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["lang"]),
  },
};
</script>
